export default class Contact {
    constructor(data) {
        this.data = {};
        this.data = data;
    }
    set id(id) {
        this.data.id = id;
    }
    get id() {
        return this.data.id;
    }
    set name(contactName) {
        this.data.contactName = contactName;
    }
    get name() {
        if (this.data.contactName) {
            return this.data.contactName;
        }
        return (this.data.firstName || '') + ' ' + (this.data.lastName || '');
    }
    set email(email) {
        this.data.email = email;
    }
    get email() {
        return this.data.email;
    }
    set phone(phone) {
        this.data.phone = phone;
    }
    get phone() {
        return this.data.phone;
    }
    set companyName(companyName) {
        this.data.companyName = companyName;
    }
    get companyName() {
        return this.data.companyName;
    }
    get timezone() {
        return this.data.timezone;
    }
    get profileColor() {
        let str = this.name;
        if (this.phone) {
            str += this.phone;
        }
        if (this.email) {
            str += this.email;
        }
        let hash = 0;
        if (str.length == 0) {
            return hash;
        }
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
            hash = hash & hash; // Convert to 32bit integer
        }
        const shortened = Math.abs(hash) % 360;
        return 'hsl(' + shortened + ',35%, 60%)';
    }
    get initials() {
        var _a, _b, _c, _d;
        try {
            if (this.name.trim()) {
                return this.name.trim().split(' ').length >= 2
                    ? ((_a = this.name.split(' ')[0][0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) +
                        ((_b = this.name.split(' ')[1][0]) === null || _b === void 0 ? void 0 : _b.toUpperCase())
                    : (_c = this.name.split(' ')[0][0]) === null || _c === void 0 ? void 0 : _c.toUpperCase();
            }
            else if (this.email) {
                return (_d = this.email.substring(0, 2)) === null || _d === void 0 ? void 0 : _d.toUpperCase();
            }
            return '-';
        }
        catch (error) {
            return '-';
        }
    }
}
